import { z } from 'zod';
import { ZodProperties } from '../../../../utils/zod';
import {
  Currency,
  IFormatSettingEditInput,
  Locale,
  TimeFormat,
} from '../../../../utils/apollo/graphqlSchema';

export const formatSettingSchema = z.object<
  ZodProperties<IFormatSettingEditInput>
>({
  currency: z.nativeEnum(Currency),
  date: z.string(),
  locale: z.nativeEnum(Locale),
  time: z.nativeEnum(TimeFormat),
});

export type IFormatSettingState = z.infer<typeof formatSettingSchema>;
